import PNG_1 from "../../../assets/images/raster/components/SuccessStories/john.png";
import WEBP_1 from "../../../assets/images/raster/components/SuccessStories/john.webp";
import PNG_2 from "../../../assets/images/raster/components/SuccessStories/mario.png";
import WEBP_2 from "../../../assets/images/raster/components/SuccessStories/mario.webp";
import PNG_3 from "../../../assets/images/raster/components/SuccessStories/emily.png";
import WEBP_3 from "../../../assets/images/raster/components/SuccessStories/emily.webp";
import PNG_4 from "../../../assets/images/raster/components/SuccessStories/silvia.png";
import WEBP_4 from "../../../assets/images/raster/components/SuccessStories/silvia.webp";

const POSTS = {
  firstItem: [
    {
      PNG: PNG_1,
      WEBP: WEBP_1,
      name: "John",
      locations: "EE. UU.",
      text: "“Usé otras herramientas antes de cambiar a AMZScout. Me gusta mucho su software para vendedores, especialmente los buscadores de palabras clave y rastreadores de productos que me dan buenas referencias.”"
    },
    {
      PNG: PNG_2,
      WEBP: WEBP_2,
      name: "Mario",
      locations: "Reino Unido",
      text: "“Honestamente, es como intentar encontrar la salida en la oscuridad y de repente obtienes una linterna. Con AMZScout, la calidad y la productividad van de la mano. Es económico y el mejor método para buscar productos y rastrear a tus competidores.”"
    }
  ],
  secondItem: [
    {
      PNG: PNG_3,
      WEBP: WEBP_3,
      name: "Emily",
      locations: "EE. UU.",
      text: "“Amazon Scout me ha ayudado a encontrar productos rentables y optimizar mis listings y campañas PPC. He visto una gran mejora desde que comencé a usar este software FBA. Si estás empezando a vender en Amazon, definitivamente pruébalo.”"
    },
    {
      PNG: PNG_4,
      WEBP: WEBP_4,
      name: "Silvia",
      locations: "ES",
      text: "“He estado usando AMZScout durante unos meses y estoy realmente impresionada. Incluye múltiples herramientas para ayudarte a hacer investigación de productos, encontrar palabras clave y más. Definitivamente recomiendo AMZScout para cualquiera que esté construyendo un negocio en Amazon.”"
    },
  ]
};
export default POSTS;
